<template>
  <div id="app">
    <!-- Načítací obrazovka -->
    <div v-if="isLoading" class="loading-screen">
      <img src="@/assets/logo.png" alt="Logo" class="w-52 animate-pulse" />
    </div>

    <!-- Obsah stránky -->
    <div v-else>
      <HeroSection />
      <HelpSection />
      <AboutSection />
      <ReviewsSection />
      <PriceSection />
      <ContactSection />

      <!-- Tlačítko pro scroll nahoru -->
      <button
          v-if="showScrollToTop"
          class="scroll-to-top bg-orange-500 hover:bg-orange-600 text-white rounded-full p-3 shadow-lg fixed bottom-6 right-6 flex items-center justify-center"
          data-aos="fade-up"
          data-aos-duration="2000"
          @click="scrollToTop"
          aria-label="Scroll to top"
      >
        <i class="pi pi-arrow-up text-xl"></i>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

import AboutSection from "./components/AboutSection.vue";
import ContactSection from "./components/ContactSection.vue";
import HelpSection from "./components/HelpSection.vue";
import HeroSection from "./components/HeroSection.vue";
import PriceSection from "./components/PriceSection.vue";
import ReviewsSection from "./components/ReviewsSection.vue";

const isLoading = ref(true);
const showScrollToTop = ref(false);

onMounted(() => {
  setTimeout(() => {
    isLoading.value = false;
  }, 1500);

  const handleScroll = () => {
    showScrollToTop.value = window.scrollY > 200;
  };

  window.addEventListener("scroll", handleScroll);

  onUnmounted(() => {
    window.removeEventListener("scroll", handleScroll);
  });
});

const scrollToTop = () => {
  window.scrollTo({
    top: 0
  });
};
</script>

<style>
.swiper-pagination-bullet-active, .swiper-pagination-bullet {
  background: #FFA416 !important;
}

.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.scroll-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #FFA416;
  color: white;
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.scroll-to-top:hover {
  background-color: #e69514;
}
</style>
